import { GitBranch, KeyRound, ServerCog } from "lucide-react";

const guidesBase = "https://github.com/zworks-ai/zworks/tree/main/docs/integrations";

export interface IntegrationGuide {
  /** The integration type a connection names, so a guide can tell whether it is already connected. */
  slug: string;
  title: string;
  category: string;
  summary: string;
  status: "not-connected" | "planned";
  guidePath: string;
  icon: typeof GitBranch;
}

export const integrationGuideStatuses: Record<
  IntegrationGuide["status"],
  { label: string; variant: "unknown" | "muted" }
> = {
  "not-connected": { label: "Not connected yet", variant: "unknown" },
  planned: { label: "Planned", variant: "muted" },
};

export const integrationGuides: IntegrationGuide[] = [
  {
    slug: "github",
    title: "GitHub",
    category: "Source control",
    summary:
      "Connect repositories so runs can clone, push, and open pull requests. The guide covers the GitHub App setup, requested scopes, and troubleshooting.",
    status: "not-connected",
    guidePath: `${guidesBase}/github.md`,
    icon: GitBranch,
  },
  {
    slug: "anthropic",
    title: "Model keys",
    category: "Model providers",
    summary:
      "Bring your own model key per project. The guide covers supported providers, key rotation, and how usage is metered.",
    status: "not-connected",
    guidePath: `${guidesBase}/model-keys.md`,
    icon: KeyRound,
  },
  {
    slug: "custom_mcp",
    title: "MCP servers",
    category: "Tools and MCP",
    summary:
      "Expose tools to runs through reviewed MCP servers. The guide covers the static allowlist, request limits, and approval for write effects.",
    status: "planned",
    guidePath: `${guidesBase}/mcp-servers.md`,
    icon: ServerCog,
  },
];
